<template>
    <div class="certification-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="certification-content">

            <el-tabs v-model="activeName"
                     type="card"
                     class="cert-tabs"
                     @tab-click="handleTabClick">
                <el-tab-pane label="待审核"
                             name="first"></el-tab-pane>
                <el-tab-pane label="已审核"
                             name="second"></el-tab-pane>
            </el-tabs>

            <div class="search-wrap">
                <div class="option-wrap">
                    <div class="option-item"
                         style="margin-right: 16px;">
                        <span class="label">姓名</span>
                        <el-input placeholder="请输入姓名"
                                  v-model="selectForm.accountName"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>

                    <div class="option-item"
                         style="margin-right: 16px;">
                        <span class="label">手机号</span>
                        <el-input placeholder="请输入手机号"
                                  v-model="selectForm.phone"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="searchQuery">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   @click="resetQuery"
                                   plain>重置</el-button>
                    </div>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column min-width="50px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accountName"
                                     label="姓名">
                    </el-table-column>
                    <el-table-column prop="phone"
                                     label="手机号">
                    </el-table-column>
                    <el-table-column prop="hospitalName"
                                     label="医院">
                    </el-table-column>
                    <el-table-column prop="videoSuffix"
                                     v-if="activeName === 'second'"
                                     label="审核状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.authenticationStatus === 2"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">审核通过</span>
                            </div>
                            <div v-else-if="scope.row.authenticationStatus === 3"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">审核不通过</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="createTime"
                                     label="申请日期">
                    </el-table-column>

                    <el-table-column label="操作"
                                     width="100">
                        <template slot-scope="scope">
                            <span @click="handleAuthClick(scope.row.incId)"
                                  class="link-btn"
                                  v-if="scope.row.authenticationStatus === 1">审核</span>
                            <span @click="handleAuthClick(scope.row.incId)"
                                  class="link-btn"
                                  v-else-if="scope.row.authenticationStatus === 2 || scope.row.authenticationStatus === 3">查看</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { postDoctorApplyList } from '@/api/certification'
export default {
    name: 'certificationList',
    data () {
        return {
            loading: false,
            activeName: 'first',
            breadList: [{ label: '用户管理' }, { label: '认证审核' }],
            dataList: [],
            selectForm: {
                accountName: '',
                phone: ''
            },
            status: [1],
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            }
        }
    },
    methods: {
        handleTabClick (tab, event) {
            let tabName = tab.name
            let arry = []
            if (tabName === 'first') {
                arry = [1]
            } else if (tabName === 'second') {
                arry = [2, 3]
            }
            this.status = arry
            this.page.current = 1
            this.queryApplyList()
        },
        // 去认证
        handleAuthClick (incId) {
            this.$router.push({
                name: 'certificateDetail',
                query: { incId: incId }
            })
        },
        // 翻页
        handlePageChange (val) {
            this.query(val)
        },
        resetQuery () {
            this.selectForm.accountName = ''
            this.selectForm.phone = ''
            this.query(1)
        },
        searchQuery () {
            this.query(1)
        },
        query (val) {
            this.page.current = val
            this.queryApplyList()
        },
        async queryApplyList () {
            let param = {
                accountName: this.selectForm.accountName,
                phone: this.selectForm.phone,
                status: this.status,
                size: this.page.pageSize,
                current: this.page.current
            }
            this.loading = true
            const { results, total } = await postDoctorApplyList(param)
            this.loading = false
            this.page.total = total
            this.dataList = results
        },
        init () {
            this.queryApplyList()
        }
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.certification-wrap {
    height: calc(100% - 70px);
    .status-warp {
        line-height: 12px;
        .el-badge {
            height: 10px;
            .el-badge__content {
                width: 6px;
                height: 6px;
            }

            .el-badge__content--success {
                background: #4acfb1;
            }
            .el-badge__content--info {
                background: #cccccc;
            }
        }
        .status_text {
            margin-left: 10px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            line-height: 12px;
        }
    }
    .certification-content {
        height: 100%;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 0;
        background: #fff;
        overflow: auto;
        .cert-tabs {
            .el-tabs__header {
                background: #f8f8f8;
                margin: 0;
                border-bottom: 1px solid #e8e8e8;
                .el-tabs__nav-wrap {
                    margin-bottom: -1px;
                }
                .el-tabs__nav {
                    border-radius: 0;
                    height: 40px;
                    .el-tabs__item {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #666666;
                        letter-spacing: 0;
                        text-align: center;
                        width: 170px;
                        height: 40px;
                        line-height: 38px;
                        border: none;
                        border-right: 1px solid #dbdbdb;
                    }
                    .is-active {
                        background: #ffffff;
                        color: #06aea6;
                        border-top: 2px solid #06aea6;
                    }
                }
            }
        }
        .title-wrap {
            padding: 0 20px;
            font-size: 0;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    display: inline-block;
                    font-size: 0;
                    margin: 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        display: inline-block;
                        width: 56px;
                        text-align: right;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }

        .table-wrap {
            padding: 0 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
        .pagination-wrap {
            padding: 0 20px;
        }
    }
}
</style>
